/**
 * Contact Slice
 *
 * Contact form section with CTA copy.
 */

import React from "react";
import { graphql } from "gatsby";
import { motion } from "framer-motion";
import { PrismicRichText } from "@prismicio/react";
import ContactForm from "../../components/ContactForm";
import BackgroundStaticVideo from "../../components/BackgroundStaticVideo";
import * as styles from "./Contact.module.scss";

export const Contact = ({ slice }) => {
  const { eyebrow, heading, copy, form_heading, color_scheme, show_background_static_video } = slice?.primary || {};
  const items = slice?.items || [];

  // Extract subject options from repeatable items
  const subjects = items
    .map(item => item.subject_option)
    .filter(Boolean);

  return (
    <section
      className={styles.contact}
      data-color-scheme={color_scheme || "white"}
      data-background-static-video={show_background_static_video ? "true" : undefined}
      id="contact"
    >
      {show_background_static_video && <BackgroundStaticVideo />}
      <div className={`page-width--slim padding-section-vertical ${styles.container}`}>
        <motion.div
          className={styles.content}
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, ease: [0.25, 0.1, 0.25, 1] }}
        >
          {eyebrow && (
            <span className={styles.eyebrow}>{eyebrow}</span>
          )}
          {heading?.richText && (
            <PrismicRichText
              field={heading.richText}
              components={{
                heading2: ({ children }) => <h2 className="h3">{children}</h2>,
              }}
            />
          )}
          {copy?.richText && (
            <div className={styles.copy}>
              <PrismicRichText field={copy.richText} />
            </div>
          )}
        </motion.div>

        <motion.div
          className={styles.form}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.7, delay: 0.15, ease: [0.25, 0.1, 0.25, 1] }}
        >
          <ContactForm heading={form_heading} subjects={subjects} />
        </motion.div>
      </div>
    </section>
  );
};

export const query = graphql`
  fragment HomepageDataBodyContact on PrismicHomepageDataBodyContact {
    primary {
      eyebrow
      heading {
        richText
        text
      }
      copy {
        richText
        text
      }
      form_heading
      color_scheme
      show_background_static_video
    }
    items {
      subject_option
    }
  }
  fragment AboutPageDataBodyContact on PrismicAboutPageDataBodyContact {
    primary {
      eyebrow
      heading {
        richText
        text
      }
      copy {
        richText
        text
      }
      form_heading
      color_scheme
      show_background_static_video
    }
    items {
      subject_option
    }
  }
`;
